import {
  useContext,
  useEffect,
} from 'react'
import { useLocation } from 'react-router-dom'

import { MenuContext } from '../ScreenWrapper/Header/Menu'

function OnNavigationChange(): null {
  const { closeMenu } = useContext(MenuContext)

  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)

    closeMenu()
  }, [ location ]) // eslint-disable-line react-hooks/exhaustive-deps

  return null // eslint-disable-line no-null/no-null
}

export default OnNavigationChange
